import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Men from "./pages/Men";
import Women from "./pages/Women";
import Cart from "./pages/Cart";
import { useEffect, useState } from "react";

function App() {

  // store products coming from API
  const [data, setData] = useState({ men: [], women: [] });

  useEffect(() => {

    // fetch men & women products together
    Promise.all([
      fetch("http://localhost:5000/men").then(res => res.json()),
      fetch("http://localhost:5000/women").then(res => res.json())
    ]).then(([menData, womenData]) => {
      setData({ men: menData, women: womenData });
    });

  }, []);

  return (
    <>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/men" element={<Men data={data.men} />} />
        <Route path="/women" element={<Women data={data.women} />} />
        <Route path="/cart" element={<Cart />} />
      </Routes>
    </>
  );
}

export default App;